/**
 * localStorage keys for asset owner wallet linking only.
 * Investor keys live in `../investor/investorWalletStorageKeys.js`.
 */
export const OWNER_WALLET_STORAGE_KEYS = {
  address: "owner_wallet_address",
  provider: "owner_wallet_provider",
};
